export default {
  EUR: 'i.iii,dd €',
  USD: '$i,iii.dd',
  GBP: '£i,iii.dd'
} as Record<string, string>;
